
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ExamV3Custom from "@/lib/model/exambuilder/exam-v3/exam-v3";
import { QuestionV2 } from "@/lib/model/exambuilder/question-v2";
import QuestionCard from "@/views/ai-builder-v3/components/question-card.vue";
import {
  jobMatchingEnum,
  physicalInstrumentEnum,
  knowledgeAndSkillsEnum
} from "@/lib/enum/tool";
import { Mind, PsycGaugeConfig, Vir } from "@/lib/model/exambuilder/exam-v2";
import { FaceVerification } from "@/lib/enum/tool";
import ExamList from "@/lib/model/exam/exam";
import { TagIcon } from "@/lib/enum/tool";
import EllipShow from "@/components/ellipShow.vue";

class TestExamList {
  id = 0;
  name = "";
  connectCode = "";
}

@Component({
  components: {
    QuestionCard,
    EllipShow
  }
})
export default class ModelDrawer extends Vue {
  @Prop({ type: Boolean, default: false }) visible!: boolean;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop({ type: Boolean, default: true }) isDetail!: boolean;
  @Prop({ default: () => [new Vir()] }) virList!: Vir[]; //虚拟人list
  @Prop({ default: () => [new PsycGaugeConfig()] })
  mindList!: PsycGaugeConfig[]; // 心理测评list
  @Prop({ default: () => new ExamV3Custom() })
  exam!: ExamV3Custom; //考试Model

  faceVerification = FaceVerification;

  testExamList: TestExamList[] = [new TestExamList()];

  // 面试时间限制
  get timeText() {
    const {
      timeLimitHours,
      timeLimitMinutes,
      timeLimitExam
    } = this.exam.settingInformation.timeConfig;

    let str = "";
    if (timeLimitHours) {
      str += `${timeLimitHours}小时`;
    }
    if (timeLimitMinutes) {
      str += `${timeLimitMinutes}分钟`;
    }
    if (!timeLimitHours && !timeLimitMinutes) {
      const h = timeLimitExam / (60 * 60);
      if (h >= 1) {
        str += `${h}小时`;
      }
      const sec = timeLimitExam % (60 * 60);
      if (sec !== 0) {
        const min = Math.floor(sec / 60);
        const s = sec % 60;
        if (s > 0) {
          str += `${min + Number(Boolean(s))}分钟`;
        }
      }
    }
    return str;
  }

  // 面试有效期
  get interviewValidityPeriod() {
    return this.exam.settingInformation.interviewValidityPeriod;
  }

  //模拟练习
  get testExam() {
    if (this.exam.settingInformation.experienceConfig.testExamSwitch === 1) {
      const result = this.testExamList.find(
        item =>
          item.id === this.exam.settingInformation.experienceConfig.testExamId
      );
      return result ? result.name : "";
    } else {
      return "";
    }
  }
  // 模拟练习题列表
  testToticList() {
    ExamList.getTestExams().then(res => {
      if (res.code === 0) {
        if (res.data.length) {
          this.testExamList = res.data;
        }
      }
    });
  }
  // 答题前登记信息项
  get paramsNameAnswerBeforeStr() {
    let str = "";
    this.exam.settingInformation.paramList.forEach(item => {
      if (item.isShow === 1 && item.saveLater !== 1) {
        str += item.name + "、";
      }
    });
    return str.slice(0, str.length - 1);
  }
  // 面试结束语前登记
  get paramsNameRegisterBeforeStr() {
    let str = "";
    this.exam.settingInformation.paramList.forEach(item => {
      if (item.isShow === 1 && item.saveLater === 1) {
        str += item.name + "、";
      }
    });
    return str.slice(0, str.length - 1);
  }

  // 面试官
  get virName() {
    const id = this.exam.settingInformation.virConfig.virVersion;
    const index = [3, 4].includes(id) ? id : id === 1 ? 4 : id === 2 ? 3 : 0;
    const vir = this.virList.find(item => item.id === index);
    if (vir) return vir.name.split(" ")[1];
    return "小娜";
  }

  // 高级设置展示
  get advancedSetting() {
    const {
      preventionCheatConfig,
      ruleConfig,
      experienceConfig
    } = this.exam.settingInformation;
    return (
      preventionCheatConfig.screenshotCheck === 1 ||
      preventionCheatConfig.mobileJoinCountCheck === 1 ||
      preventionCheatConfig.livenessRecognition === 1 ||
      preventionCheatConfig.replacePersonCheck === 1 ||
      preventionCheatConfig.faceDetection === 1 ||
      ruleConfig.isRepeatAnswerLimit === 1 ||
      ruleConfig.removeMaskTip === 1 ||
      ruleConfig.canOpenJoin === 1 ||
      experienceConfig.closeQuestionVideo === 1 ||
      experienceConfig.wxminiDeviceDetection === 1 ||
      experienceConfig.testExamSwitch === 1
    );
  }

  handleClose(select = false) {
    const flag = typeof select === "boolean" ? select : false;
    this.$emit("before-close", flag);
  }
  useTemplate() {
    if (this.disabled) return;
    this.handleClose(true);
  }
  get height() {
    return this.isDetail
      ? "calc(100% - 24px - 20px - 72px)"
      : "calc(100% - 24px - 20px - 24px)";
  }
  // 时间
  getQuestionTime(questionList: QuestionV2[]) {
    return (
      questionList.reduce((pre, item) => {
        const questionTime =
          item.getQuestionTypeText() === "视频题" ? 5 * 60 : 60;
        return pre + questionTime;
      }, 0) / 60
    );
  }

  created() {
    this.testToticList();
  }

  // 格式化用时
  get totalTime() {
    return Math.ceil(this.exam.processInformation.allTestingTime / 60);
  }
  // 题目列表
  get questionList() {
    const sortList: { questionList: QuestionV2[]; sort: number }[] = [];
    const list = [] as QuestionV2[];
    const {
      basicQualityList,
      knowledgeAndSkills: { iseChinese, iseEnglish }
    } = this.exam.processInformation;

    sortList.push(
      ...basicQualityList.map(basic => {
        {
          return {
            questionList: basic.questionList,
            sort: basic.sort
          };
        }
      })
    );
    sortList.push({
      questionList: iseChinese.questionList,
      sort: iseChinese.sort
    });
    sortList.push({
      questionList: iseEnglish.questionList,
      sort: iseEnglish.sort
    });
    // 按配分时的顺序排序
    sortList.sort((a, b) => a.sort - b.sort);
    sortList.forEach(item => {
      list.push(
        ...item.questionList.filter(
          q => q._isAssignedFlag && q.questionId !== 0
        )
      );
    });
    return list;
  }
  // 考核工具
  get toolShowList() {
    let list = [] as any[];
    const {
      basicQualityList,
      psychologicalMotivation,
      physicalInstrument,
      knowledgeAndSkills,
      jobMatching
    } = this.exam.processInformation;
    // 体质仪表
    if (physicalInstrument.fingerTest.use === 1) {
      let strName = "";
      if (physicalInstrument.fingerTest.complete === 1) {
        strName += "手部完整度、";
      }
      if (physicalInstrument.fingerTest.flexible === 1) {
        strName += "灵活度检测、";
      }
      if (physicalInstrument.fingerTest.scar === 1) {
        strName += "疤痕与纹身、";
      }
      const name =
        physicalInstrumentEnum.fingerTest +
        (strName ? `：${strName.slice(0, strName.length - 1)}` : "");
      list.push({
        name: name,
        icon: TagIcon[0],
        sort: physicalInstrument.fingerTest.sort
      });
    }
    if (physicalInstrument.colorTest.use === 1) {
      list.push({
        name: physicalInstrumentEnum.colorTest,
        icon: TagIcon[0],
        sort: physicalInstrument.colorTest.sort
      });
    }

    // 知识与技能
    for (const key in knowledgeAndSkills) {
      if (knowledgeAndSkills[key] && knowledgeAndSkills[key].use === 1) {
        list.push({
          name: knowledgeAndSkills[key].name,
          icon: TagIcon[2],
          score: knowledgeAndSkills[key].score,
          sort: knowledgeAndSkills[key].sort
        });
      }
    }
    knowledgeAndSkills.gameTestList.forEach(game => {
      if (game.gameTestType === 1) {
        game.name = "风险偏好小游戏";
        list.push({ ...game, icon: TagIcon[2] });
      }
    });
    // 基础维度
    const base = basicQualityList.map(item => {
      item.name = item.dimensionName;
      return {
        icon: TagIcon[3],
        ...item
      };
    });
    list = list.concat(base);
    // 心理动机
    this.mindList.forEach(psycConfig => {
      const psyUse = psychologicalMotivation["psyc" + psycConfig.psycGaugeId];
      if (psyUse.use === 1) {
        const data = {
          name: psycConfig.psycGaugeName,
          sort: psyUse.sort
        };
        if (psycConfig.psycGaugeId === 1) {
          const target = this.mindDimensionStr(
            psyUse.psycGaugeSubDimensionIdList,
            psycConfig.dimensionList.reduce((pre: any[], item: any) => {
              if (item.subDimensionList.length)
                pre = pre.concat(item.subDimensionList);
              return pre;
            }, [])
          );
          data.name = psycConfig.psycGaugeName + target.name;
        }
        if (psycConfig.psycGaugeId === 4) {
          const target = this.mindDimensionStr(
            psyUse.psycGaugeSubDimensionIdList,
            psycConfig.dimensionList
          );
          data.name = psycConfig.psycGaugeName + target.name;
        }

        list.push({ ...data, icon: TagIcon[4] });
      }
    });

    // 按配分时的顺序排序
    list.sort((a, b) => a.sort - b.sort);
    // 工作匹配 (排序默认最后位置，不参与排序)
    for (const key in jobMatching) {
      if (jobMatching[key] === 1) {
        list.push({ name: jobMatchingEnum[key], icon: TagIcon[1] });
      }
    }

    return list;
  }

  // 大五人格选中维度
  mindDimensionStr(idList: number[], dimensionInfo: any[]) {
    let nameStr = "";
    let topicNum = 0;
    idList.forEach((id: number) => {
      const t = dimensionInfo.find(
        psycDimension => psycDimension.psycGaugeDimensionId === id
      );
      if (t) {
        topicNum += t.questionCount;
        nameStr += t.psycGaugeDimensionName + "、";
      }
    });
    if (nameStr) {
      return {
        name: `：${(nameStr = `${topicNum}题；` + nameStr).slice(
          0,
          nameStr.length - 1
        )}`
      };
    } else {
      return {
        name: ""
      };
    }
  }
}
